import * as React from 'react'
import { SVGProps } from 'react'

function Predictions(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <g
        stroke={props.color ?? '#1D59AF'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        clipPath="url(#a)"
      >
        <path d="M7.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM16.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM7.5 19.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM16.5 13.5v6M19.5 16.5h-6" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Predictions
